module.exports = __webpack_public_path__ + "img/close_icon_blue.28f795af.svg";